import React, { useState, useEffect, useCallback } from "react";
import Layout from "../../Layout";
import "./ArtPortfolio.css";
import ShrineThumb from "../../Art/shrine.JPG";
import ShrineFull from "../../Art/shrine.JPG";
import PeachThumb from "../../Art/peach.png";
import PeachFull from "../../Art/peach.png";
import Kirby from "../../Art/kirb.png";
import KirbyFull from "../../Art/kirb.png";
import ZeldaTower from "../../Art/zelda_tower.JPG";
import ZeldaTowerFull from "../../Art/zelda_tower.JPG";
import GoTLight from "../../Art/gotlight.PNG";
import GoTLightFull from "../../Art/gotlight.PNG";
import lorena from "../../Art/lorena.jpg";
import lorenaFull from "../../Art/lorena.jpg";
import Felicia from "../../Art/Felicia.jpg";
import FeliciaFull from "../../Art/Felicia.jpg";
import Balloons from "../../Art/balloons.JPG";
import balloonsFull from "../../Art/balloons.JPG";
import GoTdark from "../../Art/gotdark.JPG";
import GoTdarkFull from "../../Art/gotdark.JPG";
import Starwars from "../../Art/starwars.JPG";
import StarwarsFull from "../../Art/starwars.JPG";
import Military from "../../Art/military.jpg";
import MilitaryFull from "../../Art/military.jpg";
import Botw from "../../Art/botw.PNG";
import BotwFull from "../../Art/botw.PNG";
import aki from "../../Art/aki.JPG";
import akiFull from "../../Art/aki.JPG";
import marin from "../../Art/marin.png";
import marinFull from "../../Art/marin.png";
import KirbyCake from "../../Art/kirby_cake.JPG";
import KirbyCakeFull from "../../Art/kirby_cake.JPG";
import ZeldaLove from "../../Art/zelda_love.JPG";
import ZeldaLoveFull from "../../Art/zelda_love.JPG";
import Cat from "../../Art/cat.JPG";
import CatFull from "../../Art/cat.JPG";
import Azura from "../../Art/Azura.JPG";
import AzuraFull from "../../Art/Azura.JPG";
import Veterans from "../../Art/veterans.JPG";
import VeteransFull from "../../Art/veterans.JPG";
import Zelda from "../../Art/zelda.JPG";
import ZeldaFull from "../../Art/zelda.JPG";
import totk from "../../Art/totk.png";
import totkFull from "../../Art/totk.png";
import KirbyStar from "../../Art/kirby.JPG";
import KirbyStarFull from "../../Art/kirby.JPG";
import ResidentEvil from "../../Art/residentevil.jpg";
import ResidentEvilFull from "../../Art/residentevil.jpg";
import Bayonetta from "../../Art/bayonetta.jpg";
import BayonettaFull from "../../Art/bayonetta.jpg";
import Dredwin from "../../Art/dredwin_commission.JPG";
import DredwinFull from "../../Art/dredwin_commission.JPG";
import Pokemon from "../../Art/pokemon.JPG";
import PokemonFull from "../../Art/pokemon.JPG";
import SkywardSword from "../../Art/skywardsword.JPG";
import SkywardSwordFull from "../../Art/skywardsword.JPG";
import SkywardSwordArt from "../../Art/skywardswordart.JPG";
import SkywardSwordArtFull from "../../Art/skywardswordart.JPG";
import Samurai from "../../Art/Samurai.png";
import SamuraiFull from "../../Art/Samurai.png";
import Sunset from "../../Art/sunset.jpg";
import SunsetFull from "../../Art/sunset.jpg";
import Mountain from "../../Art/mountain.jpg";
import MountainFull from "../../Art/mountain.jpg";
import ZeldaShootingStars from "../../Art/ZeldaShootingStars.png";
import ZeldaShootingStarsFull from "../../Art/ZeldaShootingStars.png";

import FJ_Construction from "../../Art/FJ/construction.JPG";
import FJ_Cyber from "../../Art/FJ/cyber.JPG";
import FJ_Helicopter from "../../Art/FJ/helicopter.JPG";
import FJ_Infantry from "../../Art/FJ/infantry.JPG";
import FJ_Intelligence from "../../Art/FJ/intelligence.JPG";
import FJ_Mechanic from "../../Art/FJ/mechanic.JPG";
import FJ_Medic from "../../Art/FJ/medic.JPG";
import FJ_Nurse from "../../Art/FJ/nurse.JPG";
import FJ_Tank from "../../Art/FJ/tank.JPG";
import FJ_Specialist from "../../Art/FJ/specialist.JPG";

const galleryItems = [
  {
    id: 1,
    title: "Lonely Shrine",
    date: "2022",
    caption:
      "Inspired by The Legend of Zelda: Breath of the Wild - a shrine blanketed in snow and illuminated by soft, ethereal light.",
    fullCaption:
      "I made this piece in 2022, when there was a snowstorm. There is something about winter that makes the cold feel both harsh yet cozy when you're wrapped in a warm blanket. This piece captures the serene beauty of winter, with gentle snowfall and a warm glow emanating from within the shrine, symbolizing warmth amidst the cold.",
    src: ShrineThumb,
    full: ShrineFull,
  },
  {
    id: 2,
    title: "Peaches & Petals",
    date: "2025",
    caption:
      "Princess Peach in a soft, pastel dreamscape surrounded by falling cherry blossom petals.",
    fullCaption:
      "I felt like drawing Princess Peach in a new style that also captures her feminine beauty and charm.",
    src: PeachThumb,
    full: PeachFull,
  },
  {
    id: 3,
    title: "Kirby Spotted",
    date: "2023",
    caption: "Kirby zooming through the lonely sky (Comissioned piece)",
    fullCaption:
      " After posting more liminal landscapes and artworks, I was challeneged to combine the lovable pink puffball with liminality.",
    src: Kirby,
    full: KirbyFull,
  },
  {
    id: 4,
    title: "Towering The Skies",
    date: "2022",
    caption:
      "Balancing lights and dark to bring a vibrant piece inspired by The Legend of Zelda: Breath of The Wild.",
    fullCaption:
      "It was my first semester in ROTC, and upon returning home I witnessed a beautiful sunrise. Thus, this piece was born out of sheer appreciation for the nature around me. A moment in time frozen through my love of art and video games.",
    src: ZeldaTower,
    full: ZeldaTowerFull,
  },
  {
    id: 5,
    title: "Blizzard Samurai",
    date: "2024",
    caption: "Artwork inspired by Ghost of Tsushima.",
    fullCaption:
      "After finishing Ghost of Tsushima, the story and scenery astonished me. I felt compelled to draw Jin Sakai - the protagonist - taking control of his struggles through confidence in the snow.",
    src: GoTLight,
    full: GoTLightFull,
  },
  {
    id: 6,
    title: "At Peace & Love",
    date: "2025",
    caption:
      "A gift for my friend on the 3rd anniversary of her father's death.",
    fullCaption:
      "To commemorate my friend who was mourning the death of her father 3 years after his death. I drew her and her father at the creek they would always sit together at, along with her favorite bible verse.",
    src: lorena,
    full: lorenaFull,
  },
  {
    id: 7,
    title: "Demon vs. Poison",
    date: "2024",
    caption:
      "This piece was to commemorate me and my partner's love for Street Fighter 6 (Comissioned piece)",
    fullCaption:
      "An artpiece that holds great sentiment. Street Fighter 6 is how I met my first love. From training to finding love in the most unpredictable circumstance, this piece captures our most played characters and is a tribute to our love for video games and each other.",
    src: aki,
    full: akiFull,
  },
  {
    id: 8,
    title: "Life Floats Away",
    date: "2023",
    caption:
      "Some people have more balloons than others. A tribute to our lives and how grateful we should be for ours.",
    fullCaption:
      "After coming back from Cadet Summer Training in Ft. Knox, Kentucky, I was hit with devastating news about another cadet that I knew who had passed away due to self inflicted injuries. The news had never left my mind and I was pondering on my own life. How many times have I been greedy? When should I have checked in on others? What can I do to be grateful for today? People with the most balloons fly higher than those with far less. Each balloon is a chance at life and those that fly away never come back.",
    src: Balloons,
    full: balloonsFull,
  },
  {
    id: 9,
    title: "Blizzard Samurai",
    date: "2024",
    caption: "Dark version of Jin Sakai from Ghost of Tsushima",
    fullCaption:
      "Dark version of the orginal comissioned piece. My client and I loved both versions. ",
    src: GoTdark,
    full: GoTdarkFull,
  },
  {
    id: 10,
    title: "Ahsoka & Anakin ",
    date: "2021",
    caption:
      "A soft, cinematic moment from a galaxy far, far away. (Comissioned piece).",
    fullCaption:
      "I wanted this piece to feel like a scene you stumble upon between battles — warm, still, and familiar. Star Wars has a way of making even quiet moments feel iconic. This artwork reflects that softer side of the universe. It’s my take on a calm pause within an epic story.",
    src: Starwars,
    full: StarwarsFull,
  },
  {
    id: 11,
    title: "Flying Colors",
    date: "2019",
    caption:
      "The moment a shrinking violet became the leader she was always meant to be.",
    fullCaption:
      "2019 was the year everything changed. 17 year old me, was about to be shipped to Ft. Jackson, SC. I was terrified yet excited, this is exactly what I wanted in order to be mature and tackle the world headstrong. I made this piece before departing to be in touch with myself and to give myself the confidence to complete my training. ",
    src: Military,
    full: MilitaryFull,
  },
  {
    id: 12,
    title: "My First Digital Art",
    date: "2017",
    caption:
      "A soft, peaceful moment inspired by fan art from The Legend of Zelda: Breath of The Wild. The one that started it all.",
    fullCaption:
      "BOTW has always been a comfort game for me, and I wanted this piece to feel just as gentle. The colors came naturally — calm, dreamy, and a little nostalgic. It’s meant to capture the feeling of wandering Hyrule without a rush. A small piece of serenity.",
    src: Botw,
    full: BotwFull,
  },
  {
    id: 13,
    title: "Maid & The Garden",
    date: "2023",
    caption: "A maid who is enjoying her duties while sniffing the flowers.",
    fullCaption:
      "Bogged down with ROTC and academic obligations this piece was meant to remind me that even in my duties, I can also enjoy sniffing the flowers.",
    src: Felicia,
    full: FeliciaFull,
  },
  {
    id: 14,
    title: "Marin",
    date: "2024",
    caption:
      "A bright, summery moment honoring a classic character from The Legend of Zelda: Link's Awakening. (A comissioned piece).",
    fullCaption:
      "Marin has always had a warm, gentle charm, and I wanted to capture that sweetness. This piece reminds me of summer mornings and calm days by the water. The colors are meant to feel cheerful and fresh. The client wanted that nostalgic yet dreamy atmosphere to it.",
    src: marin,
    full: marinFull,
  },
  {
    id: 15,
    title: "A Sweet Treat",
    date: "2023",
    caption:
      "Cute, sweet, and impossible not to smile at. (A commissioned piece).",
    fullCaption:
      "My client wanted a comfort piece, Kirby, pastel colors, and dessert themes. I thought what a perfect combination! I loved making something playful and soft. It’s meant to feel like a sweet treat in art form.",
    src: KirbyCake,
    full: KirbyCakeFull,
  },
  {
    id: 16,
    title: "The Hero's Love",
    date: "2023",
    caption:
      "A simple, emotional moment captured in light. (A comissioned piece).",
    fullCaption:
      "This artwork was commissioned by my client's love for Skyward Sword. I captured the tenderness in Link and Zelda’s relationship in Skyward Sword. I imagined them sharing a moment under a sky filled with falling stars — calm, gentle, and full of feeling. The softness of the lighting reflects the innocence in their bond. It’s a dreamy tribute to one of the series’ most heartfelt duos. ",
    src: ZeldaLove,
    full: ZeldaLoveFull,
  },

  {
    id: 17,
    title: "Unknown World",
    date: "2023",
    caption: "Fan art of the critically acclaimed video game - Stray.",
    fullCaption:
      "I made this piece because I love capturing small, quiet moods. I felt like Stray captured the softness and warmth of being alone. It’s simple on purpose — just comfort and calm energy. A gentle little snapshot. ",
    src: Cat,
    full: CatFull,
  },

  {
    id: 18,
    title: "Azura",
    date: "2024",
    caption: "Burdened by emotion (A commissioned piece).",
    fullCaption:
      "I was commissioned to draw the character Azura from Fire Emblem Ftaes. Azura’s design has always felt serene, and I wanted the art to reflect that. Cool tones and flowing shapes made it easy to bring her to life. It’s one of my more emotional pieces. ",
    src: Azura,
    full: AzuraFull,
  },

  {
    id: 19,
    title: "Veteran's Day",
    date: "2019",
    caption:
      "Honoring those who served, I drew this art for the Lexington Veteran's Day art contest and won!",
    fullCaption:
      "A few months after graduating from Basic Training, it was my last year of high school and my town was hosting a Veteran's Day art contest. After coming back from basic training, I had a newfound appreciation for those who serve this country. This piece captures all the feeling and heart that goes into our service. My art was chosen and was displayed in the town hall in Lexington, MA. ",
    src: Veterans,
    full: VeteransFull,
  },

  {
    id: 20,
    title: "Pumpkin Landing",
    date: "2023",
    caption:
      "Fanart of The Legend of Zelda: Skyward Sword. (A commissioned piece).",
    fullCaption: "A commissioned piece of Link flying over Pumpkin Landing.",
    src: Zelda,
    full: ZeldaFull,
  },
  {
    id: 21,
    title: "A New Purpose",
    date: "2023",
    caption:
      "A moody moment inspired by Tears of The Kingdom's deeper tone. (A commissioned piece).",
    fullCaption:
      "Tears of the Kingdom has a heavier, more mysterious energy, and I wanted this piece to reflect that. I aimed for a mood that feels like a calm breath before something big happens. It’s subtle, but it carries the spirit of the game. A small tribute to a world that left a strong impression on me.",
    src: totk,
    full: totkFull,
  },
  {
    id: 22,
    title: "Kirby's Friends",
    date: "2024",
    caption: "Bright, happy, and full of energy you'd only expect from Kirby.",
    fullCaption:
      "This piece was just pure fun and simple. Kirby’s joy is contagious, and I wanted the artwork to feel the same way. Soft colors and bright shapes helped bring that playful mood to life. It’s a little burst of happiness on canvas.",
    src: KirbyStar,
    full: KirbyStarFull,
  },
  {
    id: 23,
    title: "Not Really Alone",
    date: "2023",
    caption:
      "A bold moment inspired by the series’ dramatic tension in Resident Evil 3.",
    fullCaption:
      "Resident Evil has such a distinct atmosphere—tense, moody, and cinematic. I wanted this piece to capture that feeling without going too dark. It’s a mix of style, suspense, and a bit of attitude. My way of honoring a series that’s hard to forget.",
    src: ResidentEvil,
    full: ResidentEvilFull,
  },
  {
    id: 24,
    title: "Bayonetta",
    date: "2021",
    caption: "Stylish, dramatic, and full of attitude. (A commissioned piece).",
    fullCaption:
      "Bayonetta leaves so much room for dramatic, high-energy art. I leaned into her elegance, confidence, and over-the-top flair. The result is a piece that feels sharp, powerful, and a little bit chaotic in the best way. It was a blast to create from start to finish.",
    src: Bayonetta,
    full: BayonettaFull,
  },
  {
    id: 25,
    title: "Dredwin",
    date: "2021",
    caption: "A personalized commission full of character and style.",
    fullCaption:
      "This commission let me step into someone else’s world and bring their idea to life. I focused on capturing personality and energy in a way that still felt true to my style. Working closely with what the client envisioned made the piece really special. It’s one of those works that reminds me why I love doing commissions.",
    src: Dredwin,
    full: DredwinFull,
  },
  {
    id: 26,
    title: "Pokemon Love",
    date: "2022",
    caption:
      "A fun, nostalgic tribute to the world of Pokémon. A gift for a loved one. (A commissioned piece).",
    fullCaption:
      "This artwork came straight from childhood nostalgia and was a gift from a client to his fiance. Pokémon has always been about adventure and imagination to me, and I wanted the scene to feel lively and full of color. This was meant to capture the the couple's favorite Pokemon.",
    src: Pokemon,
    full: PokemonFull,
  },
  {
    id: 27,
    title: "Serenity",
    date: "2022",
    caption:
      "Softness meant to capture Zelda and her loftwing from The Legend of Zelda Skyward Sword.",
    fullCaption:
      "Skyward Sword has some of the most heartfelt moments, and I wanted to capture that softness. This piece imagines a calm, gentle scene between Zelda and her Loftwing, away from all the chaos. It’s about connection, trust, and a brief pause in their journey.",
    src: SkywardSword,
    full: SkywardSwordFull,
  },
  {
    id: 28,
    title: "The 3 Masters",
    date: "2022",
    caption: "the turning moment in Skyward Sword.",
    fullCaption:
      "For this piece, I wanted to show how bright and adventurous Skyward Sword feels. The characters and creatures are all in motion, almost like a snapshot taken mid-journey. The energy is playful, bold, and a little chaotic. It’s my way of celebrating how fun that world is to dive into.",
    src: SkywardSwordArt,
    full: SkywardSwordArtFull,
  },
  {
    id: 29,
    title: "Samurai",
    date: "2024",
    caption: "A dramatic moment frozen in motion. (A commission).",
    fullCaption:
      "An original character for a client's story, this piece focuses on the calm right in the middle of action. I wanted the character to feel powerful and grounded, even with all the movement around him. The artwork is about resolve—standing your ground when everything else is a blur. Strong, focused, and intense.",
    src: Samurai,
    full: SamuraiFull,
  },
  {
    id: 30,
    title: "Sunset",
    date: "2023",
    caption: "A warm, quiet moment painted in evening light.",
    fullCaption:
      "This painting started from a real sunset that felt too beautiful not to capture. I wanted the colors to feel soft and peaceful, like the end of a long day. There’s a sense of stillness in it that I really love. It’s a small reminder to slow down and just look.",
    src: Sunset,
    full: SunsetFull,
  },
  {
    id: 31,
    title: "Mountain",
    date: "2023",
    caption: "A calm, scenic view full of quiet strength.",
    fullCaption:
      "Mountains have always reminded me of resilience and patience. I tried to bring that feeling into this piece with steady lines and calm colors. It’s not loud or dramatic, but it feels solid and reassuring. A quiet landscape that says a lot without trying to.",
    src: Mountain,
    full: MountainFull,
  },
  {
    id: 32,
    title: "Lost In The Stars",
    date: "2023",
    caption: "Even a hero gets distracted by the beauty right in front of him.",
    fullCaption:
      "The falling stars add a sense of magic and softness to the scene. It’s a small snapshot of the hero Link trying to fulfill his duties but getting distracted.One of my favorite moments to bring to life.",
    src: ZeldaShootingStars,
    full: ZeldaShootingStarsFull,
  },
];

const army = [
  {
    id: 1,
    title: "Fixing",
    date: "2019",
    caption: "Construction & engineering support roles.",
    fullCaption:
      "An illustration highlighting Soldiers in construction and engineering roles. This piece reflects the precision, physical skill, and teamwork required to build and repair essential structures that support Army missions.",
    src: FJ_Construction,
    full: FJ_Construction,
  },
  {
    id: 2,
    title: "Cyber",
    date: "2019",
    caption: "Modern Army cyber defense and digital operations.",
    fullCaption:
      "A depiction of cyber operations within the U.S. Army, showcasing Soldiers who defend networks, counter digital threats, and support modern warfare through advanced technological capabilities.",
    src: FJ_Cyber,
    full: FJ_Cyber,
  },
  {
    id: 3,
    title: "Helicopter",
    date: "2019",
    caption: "Aviation specialists supporting Army air missions.",
    fullCaption:
      "This artwork captures the intensity and focus of aviation Soldiers—pilots, crew chiefs, and technicians—who operate and maintain Army helicopters to ensure mobility, reconnaissance, and combat support.",
    src: FJ_Helicopter,
    full: FJ_Helicopter,
  },
  {
    id: 4,
    title: "Infantry",
    date: "2019",
    caption: "Frontline Soldiers trained for direct combat.",
    fullCaption:
      "An illustration portraying the Infantry—the core fighting force of the Army. These Soldiers are trained for direct combat, tactical movement, and frontline operations across all terrains and conditions.",
    src: FJ_Infantry,
    full: FJ_Infantry,
  },
  {
    id: 5,
    title: "Intel",
    date: "2019",
    caption: "Signals & intelligence collection specialists.",
    fullCaption:
      "This piece represents Army intelligence roles, highlighting Soldiers who gather, analyze, and interpret critical information that shapes battlefield decisions and operational outcomes.",
    src: FJ_Intelligence,
    full: FJ_Intelligence,
  },
  {
    id: 6,
    title: "Mechanic",
    date: "2019",
    caption: "Vehicle maintenance & recovery operations.",
    fullCaption:
      "A tribute to Army mechanics who maintain, repair, and recover military vehicles. Their technical expertise ensures that armored units, transports, and tactical vehicles remain operational and mission-ready.",
    src: FJ_Mechanic,
    full: FJ_Mechanic,
  },
  {
    id: 7,
    title: "Medic",
    date: "2019",
    caption: "Emergency medical support on and off the battlefield.",
    fullCaption:
      "An illustration honoring Army combat medics who provide lifesaving care under extreme pressure. These Soldiers stabilize injuries, support evacuation, and deliver critical medical aid in both training and combat environments.",
    src: FJ_Medic,
    full: FJ_Medic,
  },
  {
    id: 8,
    title: "Nurse",
    date: "2019",
    caption: "Clinical care and medical readiness specialists.",
    fullCaption:
      "This artwork reflects Army nurses—highly trained professionals who deliver compassionate care, manage treatment plans, and support medical readiness across hospitals, clinics, and field environments.",
    src: FJ_Nurse,
    full: FJ_Nurse,
  },
  {
    id: 9,
    title: "Tank",
    date: "2019",
    caption: "Armored crews operating frontline tank units.",
    fullCaption:
      "A dynamic rendering of armored Soldiers operating within tank units. These crews command powerful armored vehicles, execute high-intensity missions, and provide heavy firepower in combat operations.",
    src: FJ_Tank,
    full: FJ_Tank,
  },
  {
    id: 10,
    title: "Specialist",
    date: "2019",
    caption: "EOD technicians skilled in ordnance disposal.",
    fullCaption:
      "This illustration highlights Explosive Ordnance Disposal (EOD) specialists. These Soldiers detect, disarm, and neutralize explosive threats, combining courage, precision, and deep technical expertise.",
    src: FJ_Specialist,
    full: FJ_Specialist,
  },
];

const testimonials = [
  {
    id: 1,
    first: "Mark",
    handle: "@b_ee_g_mark",
    date: "2022-03-02",
    text: "The artwork Sabrina created for us felt like a memory turned into a painting. She understood exactly what I wanted to express and added her own magic to it. My fiancée was genuinely moved when she saw it.",
  },
  {
    id: 2,
    first: "Eric",
    handle: "@smashultimate",
    date: "2023-02-11",
    text: "The Kirby cake turned out even better than I imagined. Sabrina’s attention to detail and her soft, pastel style made the whole piece feel cozy and special. I couldn’t stop smiling when I saw it!",
  },
  {
    id: 3,
    first: "Daniel",
    handle: "",
    date: "2024-12-19",
    text: "I asked Sabrina to illustrate a character from the book I’m writing, and the result blew me away. She understood the details, the mood, and the tone I wanted instantly. The final artwork felt like meeting my character in real life.",
  },
  {
    id: 4,
    first: "Lefty",
    handle: "@videogameheat",
    date: "2021-10-08",
    text: "The artwork has that classic Star Wars feeling — nostalgic, dramatic, and beautifully composed. Sabrina understood exactly what I was hoping for and made it even better. It’s easily one of my favorite pieces.",
  },
  {
    id: 5,
    first: "Edwin",
    handle: "@dredwin.can.sm4sh",
    date: "2021-09-27",
    text: "The logo Sabrina created for my page is spot-on. She took my concept and turned it into something polished, bold, and professional. It gave my page the identity it was missing. Communication was smooth and payment was fair.",
  },
  {
    id: 6,
    first: "Hailey",
    handle: "",
    date: "2024-08-02",
    text: "Working with Sabrina on my Marin piece was such an easy and enjoyable experience. She checked in throughout the process, asked thoughtful questions, and made sure she understood exactly what I wanted. The final artwork captured Marin’s spirit beautifully, and her communication made the entire process feel smooth and personal",
  },
];

export default function ArtPortfolio() {
  const [openIndex, setOpenIndex] = useState(null);
  const [loadingFull, setLoadingFull] = useState(true);

  useEffect(() => {
    galleryItems.forEach((img) => {
      const preload = new Image();
      preload.src = img.full;
    });
  }, []);

  const closeModal = useCallback(() => {
    setOpenIndex(null);
    setLoadingFull(true);
  }, []);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") closeModal();
    },
    [closeModal]
  );

  useEffect(() => {
    if (openIndex !== null) {
      document.addEventListener("keydown", onKeyDown);
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", onKeyDown);
        document.body.style.overflow = "auto";
      };
    }
  }, [openIndex, onKeyDown]);

  useEffect(() => {
    const els = document.querySelectorAll(".sq-reveal");
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("in-view");
        }),
      { threshold: 0.2, rootMargin: "0px 0px -10% 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const activeItem =
    openIndex === null
      ? null
      : openIndex.source === "army"
      ? army[openIndex.index]
      : galleryItems[openIndex.index];

  return (
    <Layout>
      <section className="sq-art-wrap">
        <header className="sq-art-header">
          <h1>My ꙳Art꙳ Gallery</h1>
          <p className="sq-subtext">
            This space holds the artwork that shaped me, challenged me, and
            taught me how to express myself. As a self taught artist, I pour my
            heart into every piece I create. Every illustration carries a bit of
            my personality, from soft details, lights and darks, and bold
            colors. I enjoy making liminal style art that evokes a sense of
            nostalgia and wonder, as well as fan art of my favorite video game
            characters.
            <br />
            <br />
            Welcome to the little corner of my imagination —hover to preview,
            click to view larger.
          </p>
        </header>

        {/* Main gallery */}
        <div className="sq-grid">
          {galleryItems.map((item, idx) => (
            <figure key={item.id} className="sq-item sq-reveal">
              <button
                className="sq-media"
                onClick={() => setOpenIndex({ source: "main", index: idx })}
                aria-label={`Open ${item.title} ${item.date}`}
              >
                <img
                  src={item.src}
                  alt={`${item.title} placeholder`}
                  loading="lazy"
                  decoding="async"
                  fetchpriority="low"
                />
              </button>

              <figcaption className="sq-meta">
                <div className="sq-title-row">
                  <span className="sq-title">{item.title}</span>
                  <span className="sq-dot">•</span>
                  <time className="sq-date">{item.date}</time>
                </div>
                <p className="sq-caption">{item.caption}</p>
              </figcaption>
            </figure>
          ))}
        </div>
        <div className="sq-divider"></div>
        {/* === Ft. Jackson Commission Section === */}
        <section className="sq-art-army">
          <header className="sq-art-header sq-army-header">
            <h1>Fort Jackson Commission Series</h1>

            <p className="sq-subtext sq-army-subtext">
              A 10-piece illustration series commissioned by the U.S. Army
              Recruiting Office at Fort Jackson. Each artwork highlights a
              different MOS using a unified neon-edged visual identity.
            </p>
          </header>

          <div className="sq-grid sq-grid-5">
            {army.map((item, idx) => (
              <figure key={item.id} className="sq-item sq-reveal">
                <button
                  className="sq-media"
                  onClick={() => setOpenIndex({ source: "army", index: idx })}
                  aria-label={`Open ${item.title} ${item.date}`}
                >
                  <img src={item.src} alt={item.title} loading="lazy" />
                </button>

                <figcaption className="sq-meta">
                  <div className="sq-title-row">
                    <span className="sq-title">{item.title}</span>
                    <span className="sq-dot">•</span>
                    <time className="sq-date">{item.date}</time>
                  </div>
                  <p className="sq-caption">{item.caption}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <div className="sq-divider-2"></div>

        {/* Testimonials (unchanged) */}
        <section className="sq-testimonials">
          <div className="sq-section-inner">
            <h2>
              <u>Testimonials</u>
            </h2>
            <div className="sq-t-grid">
              {testimonials.map((t) => (
                <article key={t.id} className="sq-t-card sq-reveal">
                  <div className="sq-t-header">
                    <span className="sq-quote">“</span>
                    <div className="sq-t-headtext">
                      <div className="sq-t-name">{t.first}</div>
                      {t.handle && (
                        <a
                          className="sq-t-handle"
                          href={`https://instagram.com/${t.handle.replace(
                            /^@/,
                            ""
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t.handle}
                        </a>
                      )}
                    </div>
                  </div>

                  <p className="sq-t-text">“{t.text}”</p>

                  <time className="sq-t-date">{t.date}</time>
                </article>
              ))}
            </div>
          </div>
        </section>

        <div className="sq-divider-2"></div>

        <section id="contact-card" className="contact_card">
          <div className="contact_outer">
            <h2 className="contact_title">Let’s Connect</h2>
            <p className="contact_subtitle">
              Feel free to reach out — I’d love to share more about my work or
              collaborate on new opportunities.
            </p>

            <div className="contact_box">
              <div className="contact_item">
                <i className="fa-solid fa-envelope contact_icon"></i>
                <a
                  href="mailto:qsabrina64@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Email: </b>qsabrina64@gmail.com
                </a>
              </div>

              <div className="contact_item">
                <i className="fa-brands fa-github contact_icon"></i>
                <a
                  href="https://github.com/squadir10"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>GitHub: </b> squadir10
                </a>
              </div>

              <div className="contact_item">
                <i className="fa-brands fa-linkedin contact_icon"></i>
                <a
                  href="https://linkedin.com/in/sabrina-quadir"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Linkedin.com/Sabrina-Quadir </b>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Shared modal for both galleries */}
        {openIndex !== null && activeItem && (
          <div
            className="sq-modal"
            onClick={closeModal}
            role="dialog"
            aria-modal="true"
          >
            <button
              className="sq-modal-close"
              onClick={closeModal}
              aria-label="Close"
            >
              ×
            </button>

            {loadingFull && <div className="sq-loader"></div>}

            <img
              className={`sq-modal-img ${loadingFull ? "" : "loaded"}`}
              src={activeItem.full}
              alt={`${activeItem.title} full view`}
              onLoad={() => setLoadingFull(false)}
              onClick={(e) => e.stopPropagation()}
            />

            <div className="sq-modal-meta" onClick={(e) => e.stopPropagation()}>
              <div className="sq-title-row">
                <strong>{activeItem.title}</strong>
                <span className="sq-dot">•</span>
                <time>{activeItem.date}</time>
              </div>
              <p>{activeItem.fullCaption}</p>
            </div>
          </div>
        )}
      </section>
    </Layout>
  );
}
